export default __webpack_public_path__ + "static/media/background_events.d3b735b3.webp";